import { render, staticRenderFns } from "./TickspeedRow.vue?vue&type=template&id=5395325a&scoped=true"
import script from "./TickspeedRow.vue?vue&type=script&lang=js"
export * from "./TickspeedRow.vue?vue&type=script&lang=js"
import style0 from "./TickspeedRow.vue?vue&type=style&index=0&id=5395325a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5395325a",
  null
  
)

export default component.exports